import afZA from '../mui-locales/af-za';
import enUS from '../mui-locales/en-us';

const locales = { enUS, afZA };

export default locales;
